
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Order } from '@/models/order';
import commonService from '@/services/common-services';
import authService from '@/services/auth-services';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

@Component
export default class DeliveryInfo extends Vue {
    @Prop({default: null})
    private customer: any;
    @Prop({default: null})
    private otherOption: any;
    private addressBookID = 0;
    @Prop({default: {}})
    private selectedAddress: any;
    private listAddress: any[] = [];

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get shippingMethods() {
        return DATA.shippingMethods;
    }

    get shippingMethodRules() {
        const invalidMethods = DATA.shippingMethods;
        const rule = {required: true, excluded: [] as any};
        if (invalidMethods && invalidMethods.length > 0) {
            rule.excluded = invalidMethods.map(x => { return x.value; });
        }
        return rule;
    }

    get paymentRequestOrders() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].paymentRequestOrders;
    }

    get totalWeight() {
        return this.paymentRequestOrders ? this.paymentRequestOrders.reduce((total: number, order: Order) => {
            return total + (order.isChecked ?  (order.orderWeight || 0) : 0);
        }, 0) : 0;
    }

    private async onChangeAddress() {
        const address = this.listAddress.find((p) => p.ID === this.addressBookID) || {ID: 0};
        if(address) {
            this.selectedAddress.ID = address.ID;
            this.selectedAddress.Receiver = address.Receiver;
            this.selectedAddress.Phone = address.Phone;
            this.selectedAddress.Address = address.Address;
        }
    }

    private async getAddressBook() {
        const result = await authService.addressInfo(this.userInfo.userId);
        if (result && result.status === 200) {
            this.listAddress = result.data.data;
            const address = this.listAddress.find((p) => p.IsDefault);
            if(address) {
                this.selectedAddress.ID = address.ID;
                this.selectedAddress.Receiver = address.Receiver;
                this.selectedAddress.Phone = address.Phone;
                this.selectedAddress.Address = address.Address;
            }
            this.addressBookID = this.selectedAddress ? this.selectedAddress.ID : 0;
        }
    }

    private async created() {
        if (this.listAddress.length === 0) {
            await this.getAddressBook();
        }
    }
}
